import React from "react";
import { NavigateFunction } from "react-router-dom";
import { findSelectedRowIndex } from "../../Alerts/AlertsUtils/findSelectedRowIndex";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { handleButtonShading } from "./handleButtonShading";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleArrowButtonClick = (
  clipsData: any,
  selectedRow: any,
  clipsIndexOrder: any,
  directionString: string,
  setSelectedRow: any,
  setClipsData: any,
  setVideoClipLoading: Dispatcher<boolean>,
  setVerifiedClicked: Dispatcher<boolean>,
  setUnverifiedClicked: Dispatcher<boolean>,
  setVideoURL: Dispatcher<string>,
  userFilters: any,
  navigate: NavigateFunction,
  onRowChange?: (row: any) => void
) => {
  // const clipsData = JSON.parse(localStorage.clipsData);

  // const selectedRow = JSON.parse(localStorage.clipsSelectedRow);

  // const clipsIndexOrder = JSON.parse(localStorage.clipsIndexOrder);

  if (
    (directionString === "forward" &&
      selectedRow.index !== clipsIndexOrder[clipsIndexOrder.length - 1]) ||
    (directionString === "back" && selectedRow.index !== clipsIndexOrder[0])
  ) {
    setVideoClipLoading(true);
    const currentIndex = findSelectedRowIndex(
      clipsIndexOrder,
      selectedRow.index
    );
    let newSelectedRow: any;

    directionString === "forward"
      ? (newSelectedRow = clipsData[currentIndex + 1])
      : (newSelectedRow = clipsData[currentIndex - 1]);

    setSelectedRow(newSelectedRow);
    localStorage.setItem("clipsSelectedRow", JSON.stringify(newSelectedRow));
    onRowChange?.(newSelectedRow);

    const updatedInvestigationData = clipsData;

    updatedInvestigationData.forEach((object: any) => {
      object.selected = false;
    });

    directionString === "forward"
      ? (updatedInvestigationData[currentIndex + 1].selected = true)
      : (updatedInvestigationData[currentIndex - 1].selected = true);

    setClipsData(updatedInvestigationData);

    // localStorage.setItem(
    //   "clipsData",
    //   JSON.stringify(updatedInvestigationData)
    // );

    const AxiosUI = createApi("");

    const retryFunction = () => {
      handleArrowButtonClick(
        clipsData,
        selectedRow,
        clipsIndexOrder,
        directionString,
        setSelectedRow,
        setClipsData,
        setVideoClipLoading,
        setVerifiedClicked,
        setUnverifiedClicked,
        setVideoURL,
        userFilters,
        navigate,
        onRowChange
      );
    };

    // First, fetch complete row information (same as handleRowSelected)
    AxiosUI.get(
      `clip/info/?username=${userFilters.user}&file_id=${newSelectedRow.file_id}`
    ).then(
      (response: AxiosResponse) => {
        if (response.data.file_id) {
          // Update selectedRow with complete data from API
          for (const key in response.data) {
            setSelectedRow((previousState: any) => {
              return {
                ...previousState,
                [key]: response.data[key],
              };
            });
          }
          localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));

          // Then fetch the video URL
          AxiosUI.get(
            `clip/url/?username=${userFilters.user}&file_id=${response.data.file_id}`
          ).then(
            (videoResponse: AxiosResponse) => {
              handleButtonShading(
                newSelectedRow,
                setVerifiedClicked,
                setUnverifiedClicked
              );
              setVideoURL(videoResponse.data);
              setVideoClipLoading(false);
            },
            (reason: AxiosError) => {
              universalAPIErrorHandler(reason, navigate, retryFunction, () => {
                handleButtonShading(
                  newSelectedRow,
                  setVerifiedClicked,
                  setUnverifiedClicked
                );
                const newInvestigationData = clipsData;
                newInvestigationData.forEach((object: any) => {
                  object.selected = false;
                });
                directionString === "forward"
                  ? (newInvestigationData[currentIndex + 1].selected = true)
                  : (newInvestigationData[currentIndex - 1].selected = true);
                setClipsData(newInvestigationData);
                localStorage.setItem(
                  "clipsData",
                  JSON.stringify(newInvestigationData)
                );
                setVideoURL("");
                setVideoClipLoading(false);
              });
            }
          );
        }
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          handleButtonShading(
            newSelectedRow,
            setVerifiedClicked,
            setUnverifiedClicked
          );
          const newInvestigationData = clipsData;
          newInvestigationData.forEach((object: any) => {
            object.selected = false;
          });
          directionString === "forward"
            ? (newInvestigationData[currentIndex + 1].selected = true)
            : (newInvestigationData[currentIndex - 1].selected = true);
          setClipsData(newInvestigationData);
          localStorage.setItem(
            "clipsData",
            JSON.stringify(newInvestigationData)
          );
          setVideoURL("");
          setVideoClipLoading(false);
        });
      }
    );
  }
};
